import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import GamificationScoreBoard from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/GamificationScoreBoard';
import { useContext } from 'react';
import { StyledControlBar } from './ControlBar.styled';
import FullscreenButton from '@/shared/Activities/ActivityComponents/FullscreenButton/FullscreenButton';
import ExpandedScreenButton from '../ExpandedScreenButton/ExpandedScreenButton';

export function ControlBar({ children, parentDivRef, className = '' }) {
  const fullscreenContext = useContext(FullscreenContext);
  return (
    <StyledControlBar
      className={`${className} ${
        fullscreenContext.state.isFullscreen ? 'fullscreen' : ''
      }`}
    >
      {children}
      <div className="default-controls">
        {fullscreenContext.state.isFullscreen ? (
          <GamificationScoreBoard />
        ) : (
          <ExpandedScreenButton />
        )}
        <FullscreenButton parentDivRef={parentDivRef} />
      </div>
    </StyledControlBar>
  );
}
